import { createI18n } from 'vue-i18n'
import mensagens from '@/typescript/servicos/i18n/locales'
import moment from 'moment'
import ptBrlocaleMoment from '../../../../static/js/pt-br'
import esCoLocaleMoment from '../../../../static/js/es-co'
import { observabilidadeLegada } from '@/integracoes/src-next/observabilidade'
import { ErroDeTraducao } from './i18n.excecoes'
import idiomasSuportados from './helpers/idiomasSuportados'
import {
  aplicarMarcaWhitelabel,
  type EstadoAplicacao
} from '@/typescript/servicos/marca/marcaWhitelabel.servico'

let obterEstadoAplicacao = (): EstadoAplicacao => ({})

const aplicarMarcaNasTraducoes = <TipoTraducao>(traducao: TipoTraducao): TipoTraducao => {
  return typeof traducao === 'string'
    ? aplicarMarcaWhitelabel(traducao, obterEstadoAplicacao()) as TipoTraducao
    : traducao
}

export const configurarMarcaWhitelabelI18n = (
  obterEstado: () => EstadoAplicacao
): void => {
  obterEstadoAplicacao = obterEstado
}

export const obterIdiomaDoNavegador = (): string => {
  const idiomaSalvo = localStorage.getItem('idioma')

  let idioma: string

  if (idiomaSalvo && idiomasSuportados.includes(idiomaSalvo)) {
    idioma = idiomaSalvo
  } else {
    idioma = 'pt-BR'
  }

  // Caso o idioma seja do tipo es-XX, converte para es
  if (idioma.startsWith('es')) {
    idioma = 'es'
  }

  return idioma
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: obterIdiomaDoNavegador(),
  fallbackLocale: 'pt-BR',
  messages: mensagens,
  postTranslation: aplicarMarcaNasTraducoes,
  missing: (_locale: string, key: string) => {
    observabilidadeLegada.registrarErro(new ErroDeTraducao(key), {
      origem: 'i18n',
      operacao: 'traducao',
      categoria: i18n.global.te(key, 'pt-BR') ? 'qualidade' : 'inesperado',
    })
  }
}) as any

const obterLocaleAtual = (): string => {
  const locale = i18n.global.locale

  return typeof locale === 'string'
    ? locale
    : locale?.value || 'pt-BR'
}

// Reexpõe a API legada usada em imports estáticos como o router.
i18n.t = (...args: any[]) => i18n.global.t(...args)
i18n.te = (...args: any[]) => i18n.global.te(...args)
i18n.tm = (...args: any[]) => i18n.global.tm(...args)

Object.defineProperty(i18n, 'locale', {
  get() {
    return obterLocaleAtual()
  },
  set(locale: string) {
    const localeGlobal = i18n.global.locale

    if (typeof localeGlobal === 'string') {
      i18n.global.locale = locale
    } else if (localeGlobal) {
      localeGlobal.value = locale
    }
  }
})

export const configurarMomentComLocaleAtual = (locale: string): void => {
  moment.updateLocale('pt-br', ptBrlocaleMoment)
  moment.updateLocale('es-co', esCoLocaleMoment)

  switch (locale) {
    case 'pt-BR':
      moment.locale('pt-br');
      break;
    case 'en-US':
      moment.locale('en');
      break;
    case 'es':
    case 'es-CO':
      moment.locale('es-co');
      break;
    default:
      moment.locale('pt-br');
  }
}

configurarMomentComLocaleAtual(obterLocaleAtual());

// TODO Legado movido para este arquivo
export function wp(palavra: string): string { return i18n.global.t('words.' + palavra, 2).toString() }
export function ws(palavra: string): string { return i18n.global.t('words.' + palavra, 1).toString() }
export const installI18nGlobals = (app: any): void => {
  app.config.globalProperties.$wp = wp
  app.config.globalProperties.$ws = ws
}
// TODO Legado movido para este arquivo

export default i18n
